/* wsapi3-personal-shopper v1.0 */
/* Deploy Version 2026-09-23 14:18:29 */
/* ============================================================
   wsapi3-personal-shopper — botão flutuante + sidebar de busca assistida
   por IA. Só ativa se a plataforma expuser `window.WsPersonalShopper`
   (flag nativa avisando que o app existe na loja) E a API confirmar que a
   loja pode usá-lo (/ia/search?check_limit=1, cacheado 1h em localStorage).

   Todas as chamadas REST ficam centralizadas em ApiWS.Calls (wsapi3-wsjs.js)
   — ApiWS.Calls.ia.* e ApiWS.Calls.listProducts.* — este módulo só orquestra
   UI/estado, não monta URL/fetch diretamente.
============================================================ */

// Vocabulário fechado pra classificação zero-shot da busca por foto (ver
// _getClipClassifier/_handleImageSelected) — CLIP compara a imagem contra
// cada um desses termos e devolve o mais próximo. Fica fora do objeto do
// módulo só por conveniência (é dado estático, não precisa viver em
// wsMain.modules['personal-shopper']).
const PS_IMAGE_SEARCH_LABELS = [
    'blusa', 'camisa', 'camiseta', 'vestido', 'saia', 'calça', 'calça jeans',
    'short', 'bermuda', 'jaqueta', 'casaco', 'moletom', 'suéter', 'macacão',
    'tênis', 'sapato', 'sandália', 'bolsa', 'cinto', 'boné', 'óculos', 'relógio',
];

wsMain.createModule({
    name: 'personal-shopper',
    version: '1.0',
    updatedAt: '2026-08-13',
    function: 'get',
    // Widget flutuante, não é conteúdo crítico — só monta depois que o resto
    // da página (banners, produtos, categorias etc.) já carregou.
    onlyAfter: 'all',

    _availableTtlMs: 60 * 60 * 1000,
    _state: { messages: [], products: [] },
    _initialized: false,
    _sending: false,

    async get() {
        try {
            console.log('[PersonalShopper] get() iniciado. WsPersonalShopper (bruto):', window.WsPersonalShopper);

            const enabled = await wsMain.modules['personal-shopper']._waitForFlag();
            console.log('[PersonalShopper] _waitForFlag() resolveu:', enabled);
            if (!enabled) { console.log('[PersonalShopper] abortando: flag ausente/false.'); return true; }

            const available = await wsMain.modules['personal-shopper']._checkAvailability();
            console.log('[PersonalShopper] _checkAvailability() resolveu:', available);
            if (!available) { console.log('[PersonalShopper] abortando: API/cache disse indisponível.'); return true; }

            console.log('[PersonalShopper] tudo ok, chamando _render()...');
            wsMain.modules['personal-shopper']._render();
            return true;
        } catch (error) {
            console.error('[PersonalShopper] get():', error);
            return true;
        }
    },

    // A flag é publicada pela plataforma de forma assíncrona (mesmo padrão de
    // `wsAppRecomend` em wsapi3-apps.js) — tenta por ~3s antes de desistir.
    _waitForFlag(attempt) {
        attempt = attempt || 0;
        return new Promise(resolve => {
            if (typeof window.WsPersonalShopper !== 'undefined') { resolve(!!window.WsPersonalShopper); return; }
            if (attempt >= 6) { console.log('[PersonalShopper] _waitForFlag: desistiu após', attempt, 'tentativas.'); resolve(false); return; }
            setTimeout(() => {
                wsMain.modules['personal-shopper']._waitForFlag(attempt + 1).then(resolve);
            }, 500);
        });
    },

    async _checkAvailability() {
        const storeId = Number(ApiWS.LV) || ApiWS.LV;
        const cacheKey = `ws_personal_shopper_available_${storeId}`;

        try {
            const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
            if (cached && typeof cached.available === 'boolean' && (Date.now() - cached.ts) < wsMain.modules['personal-shopper']._availableTtlMs) {
                console.log('[PersonalShopper] _checkAvailability: usando cache (' + cacheKey + '):', cached, '— idade (min):', ((Date.now() - cached.ts) / 60000).toFixed(1));
                return cached.available;
            }
            if (cached) console.log('[PersonalShopper] _checkAvailability: cache expirado/inválido, revalidando na API:', cached);
        } catch (e) { console.log('[PersonalShopper] _checkAvailability: cache corrompido, revalidando na API.', e); }

        let available = false;
        try {
            console.log('[PersonalShopper] _checkAvailability: chamando ApiWS.Calls.ia.checkAvailable() (store_id=' + storeId + ')...');
            const result = await ApiWS.Calls.ia.checkAvailable();
            console.log('[PersonalShopper] _checkAvailability: resposta bruta da API:', result);
            available = result?.result === 'success' && result?.available === true;
        } catch (error) {
            console.error('[PersonalShopper] checkAvailable:', error);
        }

        console.log('[PersonalShopper] _checkAvailability: gravando em cache ->', { available });
        try { localStorage.setItem(cacheKey, JSON.stringify({ available, ts: Date.now() })); } catch (e) { }
        return available;
    },

    _render() {
        const mod = wsMain.modules['personal-shopper'];
        const widget = document.querySelector('[data-wsjs-ps="widget"]');
        if (!widget) return;

        // Igual _moveDrawerToBody do cart-sidebar: precisa ser filho direto do
        // <body> pra competir no stacking context raiz (senão o z-index não
        // vence ancestrais com stacking context próprio, ex: <header>).
        if (widget.parentElement !== document.body) document.body.appendChild(widget);

        widget.style.display = '';
        // Balão fechado (X) em visita anterior — só ele fica escondido, o
        // ícone de busca continua normalmente (ver _dismissBalloon).
        if (mod._isBalloonDismissed()) mod._hideBalloon();
        mod._bindEvents(widget);
    },

    _bindEvents(widget) {
        if (widget.dataset.bound) return;
        widget.dataset.bound = '1';
        const mod = wsMain.modules['personal-shopper'];

        widget.querySelector('[data-wsjs-ps="launcher-btn"]')
            ?.addEventListener('click', () => mod.open());

        const balloon = widget.querySelector('[data-wsjs-ps="balloon"]');
        balloon?.addEventListener('click', (e) => {
            if (e.target.closest('[data-wsjs-ps="balloon-close"]')) return;
            mod.open();
        });

        widget.querySelector('[data-wsjs-ps="balloon-close"]')?.addEventListener('click', (e) => {
            e.stopPropagation();
            mod._dismissBalloon();
        });

        widget.querySelector('[data-wsjs-ps="overlay"]')?.addEventListener('click', () => mod.close());
        widget.querySelector('[data-wsjs-ps="close"]')?.addEventListener('click', () => mod.close());
        widget.querySelector('[data-wsjs-ps="refresh"]')?.addEventListener('click', () => mod._resetConversation());

        const input = widget.querySelector('[data-wsjs-ps="input"]');
        const send = widget.querySelector('[data-wsjs-ps="send"]');
        const submit = () => {
            if (!input || input.disabled) return;
            const value = input.value;
            input.value = '';
            mod._sendQuery(value);
        };
        send?.addEventListener('click', submit);
        input?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); submit(); }
        });

        const imageBtn = widget.querySelector('[data-wsjs-ps="image-btn"]');
        const imageInput = widget.querySelector('[data-wsjs-ps="image-input"]');
        imageBtn?.addEventListener('click', () => imageInput?.click());
        imageInput?.addEventListener('change', (e) => {
            const file = e.target.files?.[0] || null;
            e.target.value = ''; // permite escolher o mesmo arquivo de novo e ainda disparar 'change'
            if (file) mod._handleImageSelected(file);
        });

        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') return;
            if (widget.querySelector('[data-wsjs-ps="sidebar"]')?.classList.contains('ps-open')) mod.close();
        });
    },

    // Esconde o balão só nesta sessão de página (ex: ao abrir a sidebar
    // clicando no ícone) — não é a mesma coisa que fechar no X, que é
    // permanente (ver _dismissBalloon).
    _hideBalloon() {
        document.querySelector('[data-wsjs-ps="balloon"]')?.classList.add('ps-balloon-hidden');
    },

    // Fechar no X (balloon-close) é definitivo: grava em localStorage pra
    // não mostrar o balão de novo em nenhuma página/visita futura — só o
    // balão, o ícone de busca continua aparecendo normalmente.
    _dismissBalloon() {
        const mod = wsMain.modules['personal-shopper'];
        mod._hideBalloon();
        const storeId = Number(ApiWS.LV) || ApiWS.LV;
        try { localStorage.setItem(`ws_personal_shopper_balloon_dismissed_${storeId}`, '1'); } catch (e) { }
    },

    _isBalloonDismissed() {
        const storeId = Number(ApiWS.LV) || ApiWS.LV;
        try { return localStorage.getItem(`ws_personal_shopper_balloon_dismissed_${storeId}`) === '1'; } catch (e) { return false; }
    },

    open() {
        const mod = wsMain.modules['personal-shopper'];
        const sidebar = document.querySelector('[data-wsjs-ps="sidebar"]');
        const overlay = document.querySelector('[data-wsjs-ps="overlay"]');
        if (!sidebar || !overlay) return;

        mod._hideBalloon();
        sidebar.classList.add('ps-open');
        overlay.classList.add('ps-open');
        document.body.style.overflow = 'hidden';

        if (!mod._initialized) {
            mod._initialized = true;
            mod._init(); // já termina com _scrollToBottom() quando restaura conversa
        } else if (mod._state.messages.length) {
            // Reabrindo (2ª vez em diante) com conversa já carregada — o
            // usuário pode ter rolado pra cima lendo antes de fechar; leva
            // pro final de novo pra já ver a última mensagem.
            mod._scrollToBottom();
        }
    },

    close() {
        document.querySelector('[data-wsjs-ps="sidebar"]')?.classList.remove('ps-open');
        document.querySelector('[data-wsjs-ps="overlay"]')?.classList.remove('ps-open');
        document.body.style.overflow = '';
    },

    // Só roda na primeira abertura da sidebar — evita gastar as chamadas de
    // produto (nav-history/home/group) se o usuário nunca clicar no ícone.
    async _init() {
        const mod = wsMain.modules['personal-shopper'];
        const persisted = mod._loadPersisted();

        if (persisted && Array.isArray(persisted.messages) && persisted.messages.length) {
            mod._state.messages = persisted.messages;
            mod._state.products = persisted.products || [];
            mod._setChatting(true);
            persisted.messages.forEach(m => mod._appendMessage(m.role, m.content, false));
            mod._renderProducts(mod._state.products, 'slider');
            mod._scrollToBottom();
            return;
        }

        mod._renderProductsLoading();
        const produtos = await mod._loadInitialProducts();
        mod._state.products = produtos;
        mod._renderProducts(produtos);
    },

    // 1) monta uma busca a partir do histórico de navegação (ws_nav_history);
    // 2) sem histórico útil, cai pros produtos da home;
    // 3) sem produtos na home, cai pros produtos por grupo.
    async _loadInitialProducts() {
        let produtos = [];
        try {
            const q = wsMain.modules['personal-shopper']._buildNavQuery();
            if (q) {
                const data = await ApiWS.Calls.listProducts.byQuery(q);
                produtos = data?.produtos || [];
            }
            if (!produtos.length) {
                const home = await ApiWS.Calls.listProducts.home();
                produtos = home?.produtos || [];
            }
            if (!produtos.length) {
                const group = await ApiWS.Calls.listProducts.group();
                produtos = (group?.grupos || []).flatMap(g => g.produtos || []);
            }
        } catch (error) {
            console.error('[PersonalShopper] _loadInitialProducts:', error);
        }
        return produtos;
    },

    // Lê ws_nav_history, filtra product/category, tira as 3 primeiras
    // "palavras" (split por "-") da page_url de cada um, das páginas mais
    // recentes pras mais antigas, até no máximo 10 palavras no total.
    _buildNavQuery() {
        let history = [];
        try { history = JSON.parse(localStorage.getItem('ws_nav_history') || '[]'); } catch (e) { return ''; }
        if (!Array.isArray(history) || !history.length) return '';

        const relevant = history
            .filter(h => h && (h.page_type === 'product' || h.page_type === 'category') && h.page_url)
            .sort((a, b) => new Date(b.datetime || 0) - new Date(a.datetime || 0));
        if (!relevant.length) return '';

        const words = [];
        for (const entry of relevant) {
            if (words.length >= 10) break;
            const slug = entry.page_url.replace(/^\/+/, '').split('?')[0];
            const parts = slug.split('-').filter(Boolean).slice(0, 3);
            for (const w of parts) {
                if (words.length >= 10) break;
                words.push(w);
            }
        }
        // Espaço mesmo (vira "+" na querystring via URLSearchParams) — é o
        // que a API espera em "q=palavra+palavra+...".
        return words.join(' ');
    },

    // ─────────────────────────────────────────────
    // BUSCA POR FOTO — Transformers.js (CLIP zero-shot), 100% client-side,
    // sem subir a imagem pra nenhum servidor. Só carrega a lib + baixa o
    // modelo (CDN, cacheado pelo browser) na PRIMEIRA foto escolhida —
    // nada acontece só por a sidebar estar aberta.
    // ─────────────────────────────────────────────
    _clipClassifier: null,
    _clipLoadingPromise: null,

    async _getClipClassifier() {
        const mod = wsMain.modules['personal-shopper'];
        if (mod._clipClassifier) return mod._clipClassifier;
        if (mod._clipLoadingPromise) return mod._clipLoadingPromise;

        mod._clipLoadingPromise = (async () => {
            const { pipeline, env } = await import('https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.0.2');
            env.allowLocalModels = false;
            const classifier = await pipeline('zero-shot-image-classification', 'Xenova/clip-vit-base-patch32');
            mod._clipClassifier = classifier;
            return classifier;
        })();

        try {
            return await mod._clipLoadingPromise;
        } catch (error) {
            // Deixa tentar de novo numa próxima foto em vez de ficar preso
            // num erro de rede/carregamento permanente.
            mod._clipLoadingPromise = null;
            throw error;
        }
    },

    async _handleImageSelected(file) {
        const mod = wsMain.modules['personal-shopper'];
        if (!file) return;

        const btn = document.querySelector('[data-wsjs-ps="image-btn"]');
        const input = document.querySelector('[data-wsjs-ps="input"]');
        const overlay = document.querySelector('[data-wsjs-ps="image-loading"]');
        if (btn) btn.disabled = true;
        // Trava a sidebar inteira (blur de fundo + spinner centralizado) em
        // vez de só girar o ícone da câmera — igual ao loading que já existe
        // pro carregamento inicial dos produtos (.ps-products-loading).
        if (overlay) overlay.style.display = '';

        const objectUrl = URL.createObjectURL(file);
        try {
            const classifier = await mod._getClipClassifier();
            const output = await classifier(objectUrl, PS_IMAGE_SEARCH_LABELS, {
                hypothesis_template: 'uma foto de {}',
            });
            const top = Array.isArray(output) ? output[0] : null;

            if (top?.label && input) {
                input.value = `Procuro algo parecido com esta foto: ${top.label}`;
                input.focus();
            } else {
                mod._appendMessage('assistant', 'Não consegui identificar o que há na foto. Pode descrever com suas palavras?', false);
            }
        } catch (error) {
            console.error('[PersonalShopper] análise de imagem:', error);
            mod._appendMessage('assistant', 'Não consegui analisar essa imagem agora. Pode tentar descrever o que procura?', false);
        } finally {
            URL.revokeObjectURL(objectUrl);
            if (btn) btn.disabled = false;
            if (overlay) overlay.style.display = 'none';
        }
    },

    async _sendQuery(rawText) {
        const mod = wsMain.modules['personal-shopper'];
        const query = (rawText || '').trim();
        if (!query || mod._sending) return;
        mod._sending = true;

        // history = turnos JÁ trocados (antes desta pergunta) — igual ao
        // formato esperado por ApiWS.Calls.ia.search().
        const historyForApi = mod._state.messages.slice();
        mod._appendMessage('user', query);
        // A partir da primeira pergunta, a busca "desce" pro rodapé da
        // sidebar (CSS `order`, ver .ps-chatting) e os produtos recomendados
        // somem — o miolo passa a mostrar só a conversa + "Pensando...".
        mod._setChatting(true);
        mod._clearProducts();
        const thinkingEl = mod._appendThinking();
        mod._setInputEnabled(false);

        try {
            const result = await ApiWS.Calls.ia.search(query, historyForApi);

            thinkingEl?.remove();

            if (result?.result === 'success') {
                const reply = result.reply || '';
                mod._appendMessage('assistant', reply);

                const keywords = Array.isArray(result.keywords) ? result.keywords : [];
                let produtos = await mod._fetchProductsByKeywords(keywords);

                // Nunca deixa a sidebar sem nenhum produto: se a busca da IA não
                // achou nada, avisa e cai no mesmo fallback da recomendação
                // inicial (histórico de navegação -> home -> grupo).
                if (!produtos.length) {
                    mod._appendMessage('assistant', 'Infelizmente não encontramos produtos para essa busca. Enquanto isso, separamos algumas sugestões pra você:');
                    produtos = await mod._loadInitialProducts();
                }

                mod._state.products = produtos;
                mod._renderProducts(produtos, 'slider');
            } else {
                mod._appendMessage('assistant', result?.message || 'Não consegui buscar agora. Tente novamente em instantes.');
            }
        } catch (error) {
            console.error('[PersonalShopper] _sendQuery:', error);
            thinkingEl?.remove();
            mod._appendMessage('assistant', 'Não consegui buscar agora. Tente novamente em instantes.');
        } finally {
            mod._setInputEnabled(true);
            mod._sending = false;
            mod._persist();
        }
    },

    async _fetchProductsByKeywords(keywords) {
        // Cada keyword já vem como frase ("bola de futebol") — só junta
        // tudo com espaço mesmo (vira "+" na querystring), igual _buildNavQuery.
        const q = (keywords || [])
            .map(k => (k || '').trim())
            .filter(Boolean)
            .join(' ');
        if (!q) return [];
        try {
            const data = await ApiWS.Calls.listProducts.byQuery(q);
            return data?.produtos || [];
        } catch (error) {
            console.error('[PersonalShopper] _fetchProductsByKeywords:', error);
            return [];
        }
    },

    _resetConversation() {
        const mod = wsMain.modules['personal-shopper'];
        const storeId = Number(ApiWS.LV) || ApiWS.LV;
        try { localStorage.removeItem(`ws_personal_shopper_chat_${storeId}`); } catch (e) { }

        mod._state = { messages: [], products: [] };
        mod._setChatting(false);
        const list = document.querySelector('[data-wsjs-ps="messages"]');
        if (list) list.innerHTML = '';
        const input = document.querySelector('[data-wsjs-ps="input"]');
        if (input) input.value = '';

        mod._renderProductsLoading();
        mod._loadInitialProducts().then(produtos => {
            mod._state.products = produtos;
            mod._renderProducts(produtos);
        });
    },

    // ─────────────────────────────────────────────
    // Persistência (localStorage) — sobrevive a troca de página
    // ─────────────────────────────────────────────
    _persist() {
        const mod = wsMain.modules['personal-shopper'];
        const storeId = Number(ApiWS.LV) || ApiWS.LV;
        try {
            localStorage.setItem(`ws_personal_shopper_chat_${storeId}`, JSON.stringify({
                messages: mod._state.messages,
                products: mod._state.products,
            }));
        } catch (e) { }
    },

    _loadPersisted() {
        const storeId = Number(ApiWS.LV) || ApiWS.LV;
        try {
            const raw = localStorage.getItem(`ws_personal_shopper_chat_${storeId}`);
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return (parsed && Array.isArray(parsed.messages)) ? parsed : null;
        } catch (e) {
            return null;
        }
    },

    // ─────────────────────────────────────────────
    // Render helpers
    // ─────────────────────────────────────────────
    _appendMessage(role, content, track) {
        const mod = wsMain.modules['personal-shopper'];
        const list = document.querySelector('[data-wsjs-ps="messages"]');
        if (!list) return null;

        const bubble = document.createElement('div');
        bubble.className = `ps-msg ps-msg--${role}`;
        bubble.textContent = content;
        list.appendChild(bubble);

        if (track !== false) mod._state.messages.push({ role, content });
        mod._scrollToBottom();
        return bubble;
    },

    _appendThinking() {
        const list = document.querySelector('[data-wsjs-ps="messages"]');
        if (!list) return null;

        const bubble = document.createElement('div');
        bubble.className = 'ps-msg ps-msg--assistant ps-msg--thinking';
        bubble.textContent = 'Pensando...';
        list.appendChild(bubble);
        wsMain.modules['personal-shopper']._scrollToBottom();
        return bubble;
    },

    // Move a busca pro rodapé (true, via CSS `order`) ou mantém no topo
    // (false) — ligado assim que a 1ª pergunta é enviada, e também restaurado
    // já ligado quando há conversa persistida (ver _init).
    _setChatting(active) {
        document.querySelector('[data-wsjs-ps="sidebar"]')?.classList.toggle('ps-chatting', !!active);
    },

    // Some com os produtos recomendados assim que uma pergunta é enviada —
    // eles só voltam quando a resposta (com as keywords novas) chegar.
    _clearProducts() {
        const container = document.querySelector('[data-wsjs-ps="products"]');
        const empty = document.querySelector('[data-wsjs-ps="empty"]');
        if (container) {
            container.innerHTML = '';
            container.classList.remove('ps-products--slider');
            container.removeAttribute('style');
        }
        if (empty) empty.style.display = 'none';
    },

    _setInputEnabled(enabled) {
        const input = document.querySelector('[data-wsjs-ps="input"]');
        const send = document.querySelector('[data-wsjs-ps="send"]');
        if (input) input.disabled = !enabled;
        if (send) send.disabled = !enabled;
    },

    _scrollToBottom() {
        const body = document.querySelector('[data-wsjs-ps="body"]');
        if (body) body.scrollTop = body.scrollHeight;
    },

    _renderProductsLoading() {
        const container = document.querySelector('[data-wsjs-ps="products"]');
        const empty = document.querySelector('[data-wsjs-ps="empty"]');
        if (empty) empty.style.display = 'none';
        if (container) {
            container.classList.remove('ps-products--slider');
            container.removeAttribute('style');
            container.innerHTML = '<div class="ps-products-loading"><span class="ps-spinner"></span></div>';
        }
    },

    // mode 'grid' (padrão) = recomendação inicial, grade 2 colunas, cresce
    // pra baixo. mode 'slider' = resultado de uma pergunta — vira slider
    // horizontal (keenslider, já usado no resto do tema — ver createSlide em
    // wsapi3-main.js) abaixo da resposta do agente.
    _renderProducts(produtos, mode) {
        mode = mode || 'grid';
        const container = document.querySelector('[data-wsjs-ps="products"]');
        const empty = document.querySelector('[data-wsjs-ps="empty"]');
        if (!container) return;

        container.classList.toggle('ps-products--slider', mode === 'slider');
        container.removeAttribute('style');
        container.innerHTML = '';

        if (!Array.isArray(produtos) || !produtos.length) {
            if (empty) empty.style.display = '';
            return;
        }
        if (empty) empty.style.display = 'none';
        produtos.forEach(p => container.appendChild(wsMain.modules['personal-shopper']._productCard(p)));

        if (mode === 'slider') {
            const [ok, slider] = wsMain.tools.createSlide(container, {
                slides: { perView: 3.2, spacing: 16 },
                loop: false,
                dots: false,
                arrows: true,
            });
            if (ok && slider) slider.update();
        }
    },

    _productCard(p) {
        const preco = p?.precos?.preco || 0;
        const promocao = p?.precos?.preco_promocao || 0;
        const hasPromo = promocao > 0 && promocao < preco;
        const finalPrice = hasPromo ? promocao : preco;
        const foto = Array.isArray(p?.fotos)
            ? (typeof p.fotos[0] === 'string' ? p.fotos[0] : p.fotos[0]?.normal || '')
            : '';
        const url = p?.links?.ver_produto || '#';

        const card = document.createElement('a');
        card.className = 'ps-product';
        card.href = url;
        card.innerHTML = `
            <span class="ps-product__img">${foto ? `<img src="${foto}" alt="${(p.nome || '').replace(/"/g, '&quot;')}" loading="lazy">` : ''}</span>
            <span class="ps-product__name">${p.nome || ''}</span>
            <span class="ps-product__prices">
                ${hasPromo ? `<span class="ps-product__price-old">${wsMain.data.treatPrice(preco)}</span>` : ''}
                <span class="ps-product__price">${wsMain.data.treatPrice(finalPrice)}</span>
            </span>`;
        return card;
    },
});
